<template>
    <div class="event-name" v-bind:class="{ 'event-name--warning': event === 'change_wallet_key' }">
        <div class="event-name__icon">
            <component v-bind:is="getIcon"></component>
        </div>
        {{ $t(`events.${event}`) }}
    </div>
</template>

<script>
import IconIn from '@img/icons/lucide/arrow-down-left.svg?vue';
import IconOut from '@img/icons/lucide/arrow-up-right.svg?vue';
import IconBurn from '@img/icons/lucide/flame.svg?vue';
import IconJettonMint from '@img/icons/lucide/sparkles.svg?vue';
import IconNftIn from '@img/icons/lucide/image-down.svg?vue';
import IconNftOut from '@img/icons/lucide/image-up.svg?vue';
import IconNftMint from '@img/icons/lucide/image-plus.svg?vue';
import IconSwap from '@img/icons/lucide/arrow-left-right.svg?vue';
import IconContractDeploy from '@img/icons/lucide/square-dashed-bottom-code.svg?vue';
import IconSmartContractExec from '@img/icons/lucide/code.svg?vue';
import IconStakeIn from '@img/icons/lucide/hand-coins.svg?vue';
import IconStakeOut from '@img/icons/lucide/landmark.svg?vue';
import IconStakePush from '@img/icons/lucide/send.svg?vue';
import IconStakeDeposit from '@img/icons/lucide/layers-plus.svg?vue';
import IconEvaaSupply from '@img/icons/lucide/diamond-plus.svg?vue';
import IconContractCall from '@img/icons/lucide/square-code.svg?vue';
import IconStakeWithdraw from '@img/icons/lucide/layers-arrow-up.svg?vue';
import IconAuctionBid from '@img/icons/lucide/gavel.svg?vue';
import IconSubscribe from '@img/icons/lucide/bell-plus.svg?vue';
import IconUnsubscribe from '@img/icons/lucide/bell-off.svg?vue';
import IconUnknown from '@img/icons/lucide/squircle-dashed.svg?vue';
import IconDomainRenew from '@img/icons/lucide/globe.svg?vue';
import IconUpdate from '@img/icons/lucide/refresh-cw.svg?vue';
import IconCheck from '@img/icons/lucide/check.svg?vue';
import IconKeyRound from '@img/icons/lucide/key-round.svg?vue';

/* eslint-disable "quote-props" */
const iconMap = Object.freeze({
    received_gram: IconIn,
    sent_gram: IconOut,
    received_jetton: IconIn,
    sent_jetton: IconOut,
    auction_bid: IconAuctionBid,
    contract_deploy: IconContractDeploy,
    call_contract: IconContractCall,
    deploy_nft: IconNftMint,
    stake_deposit: IconStakeDeposit,
    renew_dns: IconDomainRenew,
    election_deposit: IconStakeOut,
    election_recover: IconStakeIn,
    jetton_mint: IconJettonMint,
    jetton_burn: IconBurn,
    jetton_swap: IconSwap,
    nft_purchase: IconAuctionBid,
    received_nft: IconNftIn,
    sent_nft: IconNftOut,
    smart_contract_exec: IconSmartContractExec,
    subscribe: IconSubscribe,
    unsubscribe: IconUnsubscribe,
    stake_withdrawal: IconStakeWithdraw,
    stake_withdrawal_request: IconStakeIn,
    change_dns: IconDomainRenew,
    delete_dns: IconDomainRenew,
    dex_deposit_liquidity: IconStakeDeposit,
    dex_withdraw_liquidity: IconStakeWithdraw,
    multisig_execute: IconSmartContractExec,
    multisig_approve: IconCheck,
    multisig_create_order: IconStakePush,
    jvault_stake: IconStakeDeposit,
    jvault_unstake_request: IconStakeIn,
    jvault_unstake: IconStakeWithdraw,
    jvault_claim: IconStakeIn,
    vesting_add_whitelist: IconUpdate,
    vesting_send_message: IconSmartContractExec,
    evaa_supply: IconEvaaSupply,
    evaa_withdraw: IconStakeWithdraw,
    evaa_liquidate: IconSmartContractExec,
    gasless_request: IconStakeIn,
    change_wallet_key: IconKeyRound,
    teleitem_start_auction: IconAuctionBid,
    teleitem_cancel_auction: IconAuctionBid,
});
export default {
    props: ['event'],

    computed: {
        getIcon() {
            return iconMap[this.event] || IconUnknown;
        },
    },
};
</script>

<style lang="scss">
.event-name{
    padding: 3px 10px 3px 7px;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: -0.01em;
    background: var(--nft-preview-background);
    border-radius: 8px;
    color: inherit;
    display: flex;
    align-items: center;
    //margin-right: 12px;
    //
    //&:last-child {
    //    margin-right: 0;
    //}

    &__icon {
        width: 15px;
        height: 15px;
        display: inline-flex;
        margin-right: 6px;
        color: var(--body-muted-text-color);

        &--chain {
            transform: scale(.8);
        }
    }

    // A security event: the wallet now answers to another key.
    &--warning {
        color: var(--badge-orange-color);
        background: var(--badge-orange-background-color);

        .event-name__icon {
            color: inherit;
        }
    }
}
</style>
